import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';

import { Button, Checkbox } from '@getro/rombo';
import { ChevronRight } from 'lucide-react';

export const Goals = ({ updateGoals, setGoals, goals: selectedGoals, isLoadingUpdateUserGoals, kind }) => {
  const handleGoalClick = (goalId) => {
    setGoals((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(goalId)) {
        newSet.delete(goalId);
      } else {
        newSet.add(goalId);
      }
      return newSet;
    });
  };

  const companyGoals = [
    {
      id: 'boost_sales',
      title: 'Boost Sales',
    },
    {
      id: 'hire_talent',
      title: 'Hire top talent',
    },
    {
      id: 'find_investors',
      title: 'Find investors',
    },
    {
      id: 'find_mentors',
      title: 'Find mentors and advisors',
    },
    {
      id: 'grow_network',
      title: 'Grow my network',
    },
    {
      id: 'others',
      title: 'Others',
    },
  ];

  const ecosystemGoals = [
    {
      id: 'boost_sales',
      title: 'Help my companies with sales',
    },
    {
      id: 'hire_talent',
      title: 'Help my companies with hiring',
    },
    {
      id: 'find_investors',
      title: 'Help my companies with fundraising',
    },
    {
      id: 'find_mentors',
      title: 'Help my companies with mentors and advisors',
    },
    {
      id: 'grow_network',
      title: 'Connect with industry experts',
    },
    {
      id: 'source_new_deals',
      title: 'Source new deals',
    },
    {
      id: 'others',
      title: 'Others',
    },
  ];

  const goals = kind === 'company' ? companyGoals : ecosystemGoals;

  return (
    <Flex
      sx={{
        mx: 'auto',
        mt: '100px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '40px',
      }}
    >
      <Flex sx={{ flexDirection: 'column', gap: '16px', maxWidth: '400px' }}>
        <Text as="h1" fontSize="22px" fontWeight="600" lineHeight="1.2">
          What are your goals?
        </Text>
        <Text color="text.main" fontSize="16px">
          We’ll tailor your experience to help you unlock the right intros.
        </Text>
      </Flex>
      <Flex sx={{ gap: '24px', width: '100%', flexDirection: 'column' }}>
        <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
          {goals.map((goal) => (
            <Flex
              key={goal.id}
              onClick={() => handleGoalClick(goal.id)}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                border: '1px solid',
                borderRadius: '4px',
                p: '16px',
                borderColor: 'border.subtle',
                width: '100%',
                height: '52px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <Checkbox onChange={() => handleGoalClick(goal.id)} checked={selectedGoals.has(goal.id)} />
              <Text color="text.dark" fontSize="14px" lineHeight="1.4" fontWeight="500">
                {goal.title}
              </Text>
            </Flex>
          ))}
        </Flex>
        <Button
          variant="primary"
          sx={{ width: '100%', justifyContent: 'center' }}
          icon={ChevronRight}
          iconPosition="right"
          onClick={() => updateGoals(selectedGoals)}
          loading={isLoadingUpdateUserGoals}
        >
          Continue
        </Button>
      </Flex>
    </Flex>
  );
};

Goals.propTypes = {
  updateGoals: PropTypes.func.isRequired,
  setGoals: PropTypes.func.isRequired,
  goals: PropTypes.object.isRequired,
  isLoadingUpdateUserGoals: PropTypes.bool.isRequired,
  kind: PropTypes.string.isRequired,
};
